import 'angular-modal-service';

module.exports = angular.module(__filename, [
    'angularModalService',
    require("data/settings/user-mgmt").name
]).
    service('forgotPasswordModal', ['ModalService', 'userMgmt', function (ModalService, userMgmt) {
        this.show = showForgotPasswordModal; // API

        function showForgotPasswordModal() {
            return ModalService.showModal({
                template: require('./forgot-password.html'),
                controller: ['$scope', '$timeout', '$transitions', 'close', ForgotPasswordController]
            });
        }

        function ForgotPasswordController($scope, $timeout, $transitions, close) {
            $scope.update = validateAndUpdate;
            $scope.close = close;

            // close modal on "back"
            var closeListener = $transitions.onStart({}, function() {
                close();
            });
            $scope.$on('$destroy', function() {
                if (closeListener && typeof closeListener === 'function') {
                    closeListener();
                }
            });

            function validateAndUpdate(form) {
                $scope.isBusy = true;
                $timeout(function () {
                    ResetPwdRequest(form)
                }, 500);
            }

            function ResetPwdRequest(form) {
                userMgmt.resetPasswordRequest(form.email).then(function (res) {
                    close(true);
                }, function (error) {
                    $scope.isBusy = false;
                    $scope.failed = true;
                    close(false);
                });
            }
        }
    }]
);
